import React, { useEffect } from "react";
import PieChartComp from "../Charts/PieChart";
import AreaChart from "../Charts/AreaChart";
import RadialChart from "../Charts/RadialChart";
import BarChart from "../Charts/BarChart";
import VerticalBarChart from "../Charts/VerticalBarChart";
import { useState, useRef } from "react";
import DropDownComp from "../image/DropDownComp";
import { useSelector } from "react-redux";
import MainLoader from "../../Loader/MainLoader";
import Empty from "../../Empty/Empty";

const VerticalBarmargin = { top: 10, left: 10, bottom: 20, right: 10 };
const radicalMargin = { top: 10, left: 10, bottom: 10, right: 10 };
const pieMargin = { top: 10, left: 10, bottom: 10, right: 10 };
const areaMargin = { top: 20, left: 40, bottom: 30, right: 10 };
const barMargin = { top: 10, left: 10, bottom: 10, right: 10 };

function ChartsComp({
  dateDropDown,
  setDropDown,
  setSelections,
  tatOverviewResp,
  settatOverviewStartDate,
  setStatusCountEndDate,
  getCheckAverageDetailsLoading,
  setStatusCountStartDate,
  setStartDate,
  setMonthlyBgvYear,
  setBgvCountEndDate,
  settatOverviewEndDate,
  setBgvCountStartDate,
  setStatusCountKey,
  bgvCountResp,
  apiCount,
  setEndDate,
  monthlyBgvResp,
  statusCountResp,
}) {
  const [value, setValue] = useState({ id: "", value: "" });
  const [angle, setAngle] = useState(0);
  const overallTatPercentageLoading = useSelector(
    (state) => state.overallTatPercentage.loading
  );
  const candidateStatuscountAmountSpentLoading = useSelector(
    (state) => state.candidateStatuscountAmountSpent.loading
  );
  const getBgvCountLoading = useSelector((state) => state.getBgvCount.loading);
  const currentYear = new Date().getFullYear();
  const dropDownData = [
    "All",
    "Current Week",
    "Previous Week",
    "Current Month",
    "Previous Month",
    "Current Year",
    "Previous Year",
  ];

  const rotatorRef = useRef(null);
  const getMonthlyBgvCountLoading = useSelector(
    (state) => state.getMonthlyBgvCount.loading
  );
  const lastTenYears = Array.from({ length: currentYear - 2023 + 1 }, (_, i) => currentYear - i);

  const [selectValue, setSelectedValue] = useState({
    TAT: "All",
    status: "All",
    packDetails: "All",
    candidateDetails: "All",
    AmountSpent: lastTenYears[0],
  });

  useEffect(() => {
    let val = Object.keys(statusCountResp)[0];
    setValue((prev) => ({
      ...prev,
      id: val,
      value: statusCountResp[val],
    }));
  }, [statusCountResp]);

  console.log("value", value);

  const handleYearChange = (value) => {
    setMonthlyBgvYear(value);
  };

  function handleMouseMove(node, event) {
    setValue((prev) => ({
      ...prev,
      id: node.id,
      value: node.formattedValue,
    }));
  }

  const addDaysToDate = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const calculateDateRange = (input) => {
    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (input) {
      case "Previous Week":
        const lastSunday = new Date(today);
        lastSunday.setDate(today.getDate() - (today.getDay() + 6));
        start = new Date(lastSunday);
        end = addDaysToDate(lastSunday, 6);
        break;
      case "Current Week":
        start.setDate(today.getDate() - (today.getDay() - 1));
        end.setDate(today.getDate() + (7 - today.getDay()));
        break;
      case "Previous Month":
        start.setMonth(today.getMonth() - 1, 1);
        end.setDate(0);
        break;
      case "Current Month":
        start.setMonth(today.getMonth(), 1);
        end.setMonth(today.getMonth() + 1, 0);
        break;
      case "Previous Year":
        start.setFullYear(today.getFullYear() - 1, 0, 1);
        end.setFullYear(today.getFullYear() - 1, 11, 31);
        break;
      case "Current Year":
        start.setFullYear(today.getFullYear(), 0, 1);
        end.setFullYear(today.getFullYear(), 11, 31);
        break;
      default:
        break;
    }
    const dates = {
      start: start.toISOString().split("T")[0],
      end: end.toISOString().split("T")[0],
    };
    return dates;
  };

  const handleSelectChange = (chartName, selectType) => {
    const selectedOption = chartName;

    setSelections((prevSelections) => ({
      ...prevSelections,
      [selectType]: selectedOption,
    }));

    if (selectType === "candidate_details") {
      if (selectedOption === "All") {
        setStartDate("");
        setEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        setStartDate(dates.start);
        setEndDate(dates.end);
      }
    } else if (selectType === "tat_overview") {
      if (selectedOption === "All") {
        settatOverviewStartDate("");
        settatOverviewEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        settatOverviewStartDate(dates.start);
        settatOverviewEndDate(dates.end);
      }
    } else if (selectType === "status_count") {
      if (selectedOption === "All") {
        setStatusCountStartDate("");
        setStatusCountEndDate("");
        setStatusCountKey("all");
      } else {
        const dates = calculateDateRange(selectedOption);
        setStatusCountStartDate(dates.start);
        setStatusCountEndDate(dates.end);
        setStatusCountKey("");
      }
    } else if (selectType === "pack_details") {
      if (selectedOption === "All") {
        setBgvCountStartDate("");
        setBgvCountEndDate("");
      } else {
        const dates = calculateDateRange(selectedOption);
        setBgvCountStartDate(dates.start);
        setBgvCountEndDate(dates.end);
      }
    } else {
    }
  };
  function handleMouseMove(node, event) {
    setValue((prev) => ({
      ...prev,
      id: node.id,
      value: node.formattedValue,
    }));
    const rotaterAngles = rotatorRef.current.getBoundingClientRect();
    console.log("right", rotaterAngles.width / 2);
    console.log("top", rotaterAngles.height / 2);
    const centerX = rotaterAngles.width / 2;
    const centerY = rotaterAngles.height / 2;
    console.log("event", event);
    const Xvalue = event.clientX - rotaterAngles.left - centerX;
    const Yvalue = event.clientY - rotaterAngles.top - centerY;
    const angleRadians = Math.atan2(Yvalue, Xvalue);
    // Convert the angle to degrees
    let angleDegrees = angleRadians * (180 / Math.PI);
    // Normalize the angle to be in the range of 0° to 360°
    if (angleDegrees < 0) {
      angleDegrees += 360;
    }
    // setAngle((node.arc.startAngle) * (180/Math.PI));
    setAngle(angleDegrees + 90);
  }

  console.log("apiCount", apiCount);
  return (
    <div className='chartsContainer'>
      <div className='chartsTopContainer'>
        <div className='leftBar'>
          <div className='overview'>
            <div className='heading'>
              <h1>TAT Overview</h1>
              <div
                onClick={() => setDropDown((prev) => ({...prev, TAT: !prev.TAT, }))}>
                <svg xmlns='http://www.w3.org/2000/svg' width='1.25rem' height='1.25rem' viewBox='0 0 26 26' fill='none'>
                  <path d='M7.53711 16.9837C7.53711 16.5348 7.88633 16.1712 8.31711 16.1712H13.8701C14.3009 16.1712 14.6501 16.5348 14.6501 16.9837C14.6501 17.4324 14.3009 17.7962 13.8701 17.7962H8.31711C7.88633 17.7962 7.53711 17.4324 7.53711 16.9837ZM8.31711 13.0938C7.88633 13.0938 7.53711 13.4574 7.53711 13.9062C7.53711 14.355 7.88633 14.7187 8.31711 14.7187H11.4372C11.8679 14.7187 12.2172 14.355 12.2172 13.9062C12.2172 13.4574 11.8679 13.0938 11.4372 13.0938H8.31711Z' fill='var(--AccentColor)' />
                  <path fillRule='evenodd' clipRule='evenodd' d='M9.05133 4.0625C9.48211 4.0625 9.83133 4.42627 9.83133 4.875V5.14956C10.2198 5.14582 10.6338 5.14582 11.0742 5.14583H14.3084C14.7488 5.14582 15.1628 5.14582 15.5513 5.14956V4.875C15.5513 4.42627 15.9005 4.0625 16.3313 4.0625C16.7622 4.0625 17.1113 4.42627 17.1113 4.875V5.203C17.3473 5.22028 17.5696 5.24277 17.7788 5.27206C18.7149 5.40317 19.5031 5.68363 20.1291 6.33571C20.755 6.98779 21.0243 7.80882 21.1501 8.78394C21.2714 9.72316 21.2714 10.9173 21.2713 12.3989V15.7471C21.2713 16.7267 21.2714 17.5167 21.2159 18.1541C21.1588 18.8109 21.0378 19.3848 20.7488 19.9063C20.4065 20.5239 19.9142 21.0367 19.3213 21.3932C18.8208 21.6942 18.2698 21.8202 17.6392 21.8798C17.0274 21.9375 16.269 21.9375 15.3285 21.9375H11.0743C9.65197 21.9375 8.50555 21.9375 7.60391 21.8113C6.66779 21.6802 5.8796 21.3997 5.25361 20.7477C4.62762 20.0955 4.35837 19.2746 4.23251 18.2995C4.11129 17.3602 4.11131 16.166 4.11133 14.6845V12.3989C4.11131 10.9173 4.11129 9.72314 4.23251 8.78394C4.35837 7.80882 4.62762 6.98779 5.25361 6.33571C5.8796 5.68363 6.66779 5.40317 7.60391 5.27206C7.81307 5.24277 8.03542 5.22028 8.27133 5.203V4.875C8.27133 4.42627 8.62054 4.0625 9.05133 4.0625ZM15.5513 6.77485V7.04167C15.5513 7.49039 15.9005 7.85417 16.3313 7.85417C16.7622 7.85417 17.1113 7.49039 17.1113 7.04167V6.83229C17.2739 6.84584 17.4267 6.86239 17.5709 6.88258C18.334 6.98945 18.7382 7.18494 19.0259 7.48476C19.3138 7.78458 19.5014 8.20553 19.6041 9.00046C19.6234 9.15065 19.6393 9.30979 19.6523 9.47917H5.73032C5.74333 9.30979 5.75922 9.15065 5.77859 9.00046C5.8812 8.20553 6.06886 7.78458 6.3567 7.48476C6.64453 7.18494 7.04864 6.98945 7.81177 6.88258C7.95594 6.86239 8.10873 6.84584 8.27133 6.83229V7.04167C8.27133 7.49039 8.62054 7.85417 9.05133 7.85417C9.48211 7.85417 9.83133 7.49039 9.83133 7.04167V6.77485C10.2227 6.77101 10.6539 6.77083 11.1313 6.77083H14.2513C14.7288 6.77083 15.1599 6.77101 15.5513 6.77485ZM5.67518 11.1042C5.67149 11.5119 5.67133 11.9611 5.67133 12.4583V14.625C5.67133 16.18 5.67298 17.2645 5.77859 18.0829C5.8812 18.8778 6.06886 19.2987 6.3567 19.5986C6.64453 19.8984 7.04864 20.0939 7.81177 20.2008C8.59734 20.3108 9.63849 20.3125 11.1313 20.3125H15.2913C16.2777 20.3125 16.9653 20.3117 17.4984 20.2614C18.0209 20.2121 18.3178 20.1203 18.5413 19.986C18.8971 19.772 19.1924 19.4643 19.3978 19.0938C19.5269 18.8609 19.6149 18.5515 19.6623 18.0074C19.7106 17.4521 19.7113 16.7358 19.7113 15.7083V12.4583C19.7113 11.9611 19.7112 11.5119 19.7074 11.1042H5.67518Z' fill='var(--AccentColor)'/>
                </svg>
                <p>{selectValue.TAT}</p>
                <svg xmlns='http://www.w3.org/2000/svg' width='0.875rem' height='0.5rem' viewBox='0 0 14 8' fill='none'>
                  <path d='M12.5 1L7 7L1.5 1' stroke='var(--AccentColor)' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              {dateDropDown.TAT &&
                (
                  <DropDownComp
                    data={dropDownData}
                    setSelectedValue={setSelectedValue}
                    closeDropDown={() => setDropDown((prev) => ({...prev, TAT: false}))}
                    handleSelectChange={handleSelectChange}
                    chartName='tat_overview'
                  />
                )
              }
            </div>
            <div className='chartArea'>
              {overallTatPercentageLoading ? (
                <MainLoader />
              ) : (
                <div className='radialContainer'>
                  {Object.values(tatOverviewResp).some(
                    (value) => value !== 0
                  ) ? (
                    <>
                      <div className='radialInner'>
                        <RadialChart marginValue={radicalMargin} data={tatOverviewResp}/>
                      </div>
                      <div className='radialLegends'>
                        <div className='legendDetails'>
                          <p>100%</p>
                          <p>Total TAT Rate</p>
                        </div>
                        <div className='legendDetails'>
                          <p>{tatOverviewResp.positive_per}%</p>
                          <p>Completion Rate</p>
                        </div>
                        <div className='legendDetails'>
                          <p>{tatOverviewResp.negative_per}%</p>
                          <p>TAT Breach Rate</p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <Empty sign='negative' size={6}/>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className='statusChart'>
            <div className='heading'>
              <h1>Status</h1>
              <div onClick={() => setDropDown((prev) => ({...prev, status: !prev.status}))}>
                <svg xmlns='http://www.w3.org/2000/svg' width='1.25rem' height='1.25rem' viewBox='0 0 26 26' fill='none'>
                  <path d='M7.53711 16.9837C7.53711 16.5348 7.88633 16.1712 8.31711 16.1712H13.8701C14.3009 16.1712 14.6501 16.5348 14.6501 16.9837C14.6501 17.4324 14.3009 17.7962 13.8701 17.7962H8.31711C7.88633 17.7962 7.53711 17.4324 7.53711 16.9837ZM8.31711 13.0938C7.88633 13.0938 7.53711 13.4574 7.53711 13.9062C7.53711 14.355 7.88633 14.7187 8.31711 14.7187H11.4372C11.8679 14.7187 12.2172 14.355 12.2172 13.9062C12.2172 13.4574 11.8679 13.0938 11.4372 13.0938H8.31711Z' fill='var(--AccentColor)'/>
                  <path fillRule='evenodd' clipRule='evenodd' d='M9.05133 4.0625C9.48211 4.0625 9.83133 4.42627 9.83133 4.875V5.14956C10.2198 5.14582 10.6338 5.14582 11.0742 5.14583H14.3084C14.7488 5.14582 15.1628 5.14582 15.5513 5.14956V4.875C15.5513 4.42627 15.9005 4.0625 16.3313 4.0625C16.7622 4.0625 17.1113 4.42627 17.1113 4.875V5.203C17.3473 5.22028 17.5696 5.24277 17.7788 5.27206C18.7149 5.40317 19.5031 5.68363 20.1291 6.33571C20.755 6.98779 21.0243 7.80882 21.1501 8.78394C21.2714 9.72316 21.2714 10.9173 21.2713 12.3989V15.7471C21.2713 16.7267 21.2714 17.5167 21.2159 18.1541C21.1588 18.8109 21.0378 19.3848 20.7488 19.9063C20.4065 20.5239 19.9142 21.0367 19.3213 21.3932C18.8208 21.6942 18.2698 21.8202 17.6392 21.8798C17.0274 21.9375 16.269 21.9375 15.3285 21.9375H11.0743C9.65197 21.9375 8.50555 21.9375 7.60391 21.8113C6.66779 21.6802 5.8796 21.3997 5.25361 20.7477C4.62762 20.0955 4.35837 19.2746 4.23251 18.2995C4.11129 17.3602 4.11131 16.166 4.11133 14.6845V12.3989C4.11131 10.9173 4.11129 9.72314 4.23251 8.78394C4.35837 7.80882 4.62762 6.98779 5.25361 6.33571C5.8796 5.68363 6.66779 5.40317 7.60391 5.27206C7.81307 5.24277 8.03542 5.22028 8.27133 5.203V4.875C8.27133 4.42627 8.62054 4.0625 9.05133 4.0625ZM15.5513 6.77485V7.04167C15.5513 7.49039 15.9005 7.85417 16.3313 7.85417C16.7622 7.85417 17.1113 7.49039 17.1113 7.04167V6.83229C17.2739 6.84584 17.4267 6.86239 17.5709 6.88258C18.334 6.98945 18.7382 7.18494 19.0259 7.48476C19.3138 7.78458 19.5014 8.20553 19.6041 9.00046C19.6234 9.15065 19.6393 9.30979 19.6523 9.47917H5.73032C5.74333 9.30979 5.75922 9.15065 5.77859 9.00046C5.8812 8.20553 6.06886 7.78458 6.3567 7.48476C6.64453 7.18494 7.04864 6.98945 7.81177 6.88258C7.95594 6.86239 8.10873 6.84584 8.27133 6.83229V7.04167C8.27133 7.49039 8.62054 7.85417 9.05133 7.85417C9.48211 7.85417 9.83133 7.49039 9.83133 7.04167V6.77485C10.2227 6.77101 10.6539 6.77083 11.1313 6.77083H14.2513C14.7288 6.77083 15.1599 6.77101 15.5513 6.77485ZM5.67518 11.1042C5.67149 11.5119 5.67133 11.9611 5.67133 12.4583V14.625C5.67133 16.18 5.67298 17.2645 5.77859 18.0829C5.8812 18.8778 6.06886 19.2987 6.3567 19.5986C6.64453 19.8984 7.04864 20.0939 7.81177 20.2008C8.59734 20.3108 9.63849 20.3125 11.1313 20.3125H15.2913C16.2777 20.3125 16.9653 20.3117 17.4984 20.2614C18.0209 20.2121 18.3178 20.1203 18.5413 19.986C18.8971 19.772 19.1924 19.4643 19.3978 19.0938C19.5269 18.8609 19.6149 18.5515 19.6623 18.0074C19.7106 17.4521 19.7113 16.7358 19.7113 15.7083V12.4583C19.7113 11.9611 19.7112 11.5119 19.7074 11.1042H5.67518Z' fill='var(--AccentColor)'/>
                </svg>
                <p>{selectValue.status}</p>
                <svg xmlns='http://www.w3.org/2000/svg' width='0.875rem' height='0.5rem' viewBox='0 0 14 8' fill='none'>
                  <path d='M12.5 1L7 7L1.5 1' stroke='var(--AccentColor)' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              {dateDropDown.status && (
                <DropDownComp
                  data={dropDownData}
                  setSelectedValue={setSelectedValue}
                  closeDropDown={() => setDropDown((prev) => ({...prev, status: false}))}
                  handleSelectChange={handleSelectChange}
                  chartName='status_count'
                />
              )}
            </div>
            <div className='chartArea'>
              <div className='pieContainer'>
                {!candidateStatuscountAmountSpentLoading ? (
                  <>
                    {Object.values(statusCountResp).some(
                      (value) => value !== 0
                    ) ? (
                      <>
                        <div className='pieInner' ref={rotatorRef}>
                          <PieChartComp handleMouseMove={handleMouseMove} marginValue={pieMargin} data={statusCountResp}/>
                          {Object.values(statusCountResp)?.some(
                            (value) => value !== 0
                          ) && (
                            <>
                              <div className='rotator'>
                                <p>{value.value}</p>
                                <p>{value.id === "invitation" ? "Invited" : value.id}</p>
                              </div>
                              <div className='duplicate' style={{transform: `rotate(${angle}deg)`}}></div>
                            </>
                          )}
                        </div>
                        <div className='pieLegendContainer'>
                          <div className='pieLegends'>
                            <p>Invited</p>
                            <p>Accepted</p>
                            <p>Pending</p>
                            <p>Cancelled</p>
                            <p>Reintiated</p>
                            <p>In Progress</p>
                            <p>Completed</p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <Empty sign='negative' size={6}/>
                    )}
                  </>
                ) : (
                  <>
                    <MainLoader />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='rightBar'>
          <div className='amountSpent'>
            <div className='heading'>
              <h1>Amount Spent</h1>
              <div onClick={() => setDropDown((prev) => ({...prev, AmountSpent: !prev.AmountSpent}))}>
                <svg xmlns='http://www.w3.org/2000/svg' width='1.25rem' height='1.25rem' viewBox='0 0 26 26' fill='none'>
                  <path d='M7.53711 16.9837C7.53711 16.5348 7.88633 16.1712 8.31711 16.1712H13.8701C14.3009 16.1712 14.6501 16.5348 14.6501 16.9837C14.6501 17.4324 14.3009 17.7962 13.8701 17.7962H8.31711C7.88633 17.7962 7.53711 17.4324 7.53711 16.9837ZM8.31711 13.0938C7.88633 13.0938 7.53711 13.4574 7.53711 13.9062C7.53711 14.355 7.88633 14.7187 8.31711 14.7187H11.4372C11.8679 14.7187 12.2172 14.355 12.2172 13.9062C12.2172 13.4574 11.8679 13.0938 11.4372 13.0938H8.31711Z' fill='var(--AccentColor)'/>
                  <path fillRule='evenodd' clipRule='evenodd' d='M9.05133 4.0625C9.48211 4.0625 9.83133 4.42627 9.83133 4.875V5.14956C10.2198 5.14582 10.6338 5.14582 11.0742 5.14583H14.3084C14.7488 5.14582 15.1628 5.14582 15.5513 5.14956V4.875C15.5513 4.42627 15.9005 4.0625 16.3313 4.0625C16.7622 4.0625 17.1113 4.42627 17.1113 4.875V5.203C17.3473 5.22028 17.5696 5.24277 17.7788 5.27206C18.7149 5.40317 19.5031 5.68363 20.1291 6.33571C20.755 6.98779 21.0243 7.80882 21.1501 8.78394C21.2714 9.72316 21.2714 10.9173 21.2713 12.3989V15.7471C21.2713 16.7267 21.2714 17.5167 21.2159 18.1541C21.1588 18.8109 21.0378 19.3848 20.7488 19.9063C20.4065 20.5239 19.9142 21.0367 19.3213 21.3932C18.8208 21.6942 18.2698 21.8202 17.6392 21.8798C17.0274 21.9375 16.269 21.9375 15.3285 21.9375H11.0743C9.65197 21.9375 8.50555 21.9375 7.60391 21.8113C6.66779 21.6802 5.8796 21.3997 5.25361 20.7477C4.62762 20.0955 4.35837 19.2746 4.23251 18.2995C4.11129 17.3602 4.11131 16.166 4.11133 14.6845V12.3989C4.11131 10.9173 4.11129 9.72314 4.23251 8.78394C4.35837 7.80882 4.62762 6.98779 5.25361 6.33571C5.8796 5.68363 6.66779 5.40317 7.60391 5.27206C7.81307 5.24277 8.03542 5.22028 8.27133 5.203V4.875C8.27133 4.42627 8.62054 4.0625 9.05133 4.0625ZM15.5513 6.77485V7.04167C15.5513 7.49039 15.9005 7.85417 16.3313 7.85417C16.7622 7.85417 17.1113 7.49039 17.1113 7.04167V6.83229C17.2739 6.84584 17.4267 6.86239 17.5709 6.88258C18.334 6.98945 18.7382 7.18494 19.0259 7.48476C19.3138 7.78458 19.5014 8.20553 19.6041 9.00046C19.6234 9.15065 19.6393 9.30979 19.6523 9.47917H5.73032C5.74333 9.30979 5.75922 9.15065 5.77859 9.00046C5.8812 8.20553 6.06886 7.78458 6.3567 7.48476C6.64453 7.18494 7.04864 6.98945 7.81177 6.88258C7.95594 6.86239 8.10873 6.84584 8.27133 6.83229V7.04167C8.27133 7.49039 8.62054 7.85417 9.05133 7.85417C9.48211 7.85417 9.83133 7.49039 9.83133 7.04167V6.77485C10.2227 6.77101 10.6539 6.77083 11.1313 6.77083H14.2513C14.7288 6.77083 15.1599 6.77101 15.5513 6.77485ZM5.67518 11.1042C5.67149 11.5119 5.67133 11.9611 5.67133 12.4583V14.625C5.67133 16.18 5.67298 17.2645 5.77859 18.0829C5.8812 18.8778 6.06886 19.2987 6.3567 19.5986C6.64453 19.8984 7.04864 20.0939 7.81177 20.2008C8.59734 20.3108 9.63849 20.3125 11.1313 20.3125H15.2913C16.2777 20.3125 16.9653 20.3117 17.4984 20.2614C18.0209 20.2121 18.3178 20.1203 18.5413 19.986C18.8971 19.772 19.1924 19.4643 19.3978 19.0938C19.5269 18.8609 19.6149 18.5515 19.6623 18.0074C19.7106 17.4521 19.7113 16.7358 19.7113 15.7083V12.4583C19.7113 11.9611 19.7112 11.5119 19.7074 11.1042H5.67518Z' fill='var(--AccentColor)'/>
                </svg>
                <p>{selectValue.AmountSpent}</p>
                <svg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8' fill='none'>
                  <path d='M12.5 1L7 7L1.5 1' stroke='var(--AccentColor)' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              {dateDropDown.AmountSpent && (
                <DropDownComp
                  setSelectedValue={setSelectedValue}
                  handleYearChange={handleYearChange}
                  data={lastTenYears}
                  closeDropDown={() => setDropDown((prev) => ({...prev, AmountSpent: false}))}
                  handleSelectChange={handleSelectChange}
                  chartName='Amount_spent'
                />
              )}
            </div>
            <div className='chartArea'>
              {getMonthlyBgvCountLoading ? (
                <MainLoader />
              ) : (
                <>
                  {monthlyBgvResp.length > 0 &&
                    Object.values(monthlyBgvResp[0]?.data).some(
                      (value) => value.y !== 0
                    ) ? (
                      <AreaChart marginValue={areaMargin} data={monthlyBgvResp}/>
                    ) : (
                    <Empty sign='negative' size={6}/>
                  )}
                </>
              )}
            </div>
          </div>
          <div className='packDetails'>
            <div className='heading'>
              <h1>Pack Usage Overview</h1>
              <div onClick={() => setDropDown((prev) => ({...prev, packDetails: !prev.packDetails}))}>
                <svg xmlns='http://www.w3.org/2000/svg' width='1.25rem' height='1.25rem' viewBox='0 0 26 26' fill='none'>
                  <path d='M7.53711 16.9837C7.53711 16.5348 7.88633 16.1712 8.31711 16.1712H13.8701C14.3009 16.1712 14.6501 16.5348 14.6501 16.9837C14.6501 17.4324 14.3009 17.7962 13.8701 17.7962H8.31711C7.88633 17.7962 7.53711 17.4324 7.53711 16.9837ZM8.31711 13.0938C7.88633 13.0938 7.53711 13.4574 7.53711 13.9062C7.53711 14.355 7.88633 14.7187 8.31711 14.7187H11.4372C11.8679 14.7187 12.2172 14.355 12.2172 13.9062C12.2172 13.4574 11.8679 13.0938 11.4372 13.0938H8.31711Z' fill='var(--AccentColor)'/>
                  <path fillRule='evenodd' clipRule='evenodd' d='M9.05133 4.0625C9.48211 4.0625 9.83133 4.42627 9.83133 4.875V5.14956C10.2198 5.14582 10.6338 5.14582 11.0742 5.14583H14.3084C14.7488 5.14582 15.1628 5.14582 15.5513 5.14956V4.875C15.5513 4.42627 15.9005 4.0625 16.3313 4.0625C16.7622 4.0625 17.1113 4.42627 17.1113 4.875V5.203C17.3473 5.22028 17.5696 5.24277 17.7788 5.27206C18.7149 5.40317 19.5031 5.68363 20.1291 6.33571C20.755 6.98779 21.0243 7.80882 21.1501 8.78394C21.2714 9.72316 21.2714 10.9173 21.2713 12.3989V15.7471C21.2713 16.7267 21.2714 17.5167 21.2159 18.1541C21.1588 18.8109 21.0378 19.3848 20.7488 19.9063C20.4065 20.5239 19.9142 21.0367 19.3213 21.3932C18.8208 21.6942 18.2698 21.8202 17.6392 21.8798C17.0274 21.9375 16.269 21.9375 15.3285 21.9375H11.0743C9.65197 21.9375 8.50555 21.9375 7.60391 21.8113C6.66779 21.6802 5.8796 21.3997 5.25361 20.7477C4.62762 20.0955 4.35837 19.2746 4.23251 18.2995C4.11129 17.3602 4.11131 16.166 4.11133 14.6845V12.3989C4.11131 10.9173 4.11129 9.72314 4.23251 8.78394C4.35837 7.80882 4.62762 6.98779 5.25361 6.33571C5.8796 5.68363 6.66779 5.40317 7.60391 5.27206C7.81307 5.24277 8.03542 5.22028 8.27133 5.203V4.875C8.27133 4.42627 8.62054 4.0625 9.05133 4.0625ZM15.5513 6.77485V7.04167C15.5513 7.49039 15.9005 7.85417 16.3313 7.85417C16.7622 7.85417 17.1113 7.49039 17.1113 7.04167V6.83229C17.2739 6.84584 17.4267 6.86239 17.5709 6.88258C18.334 6.98945 18.7382 7.18494 19.0259 7.48476C19.3138 7.78458 19.5014 8.20553 19.6041 9.00046C19.6234 9.15065 19.6393 9.30979 19.6523 9.47917H5.73032C5.74333 9.30979 5.75922 9.15065 5.77859 9.00046C5.8812 8.20553 6.06886 7.78458 6.3567 7.48476C6.64453 7.18494 7.04864 6.98945 7.81177 6.88258C7.95594 6.86239 8.10873 6.84584 8.27133 6.83229V7.04167C8.27133 7.49039 8.62054 7.85417 9.05133 7.85417C9.48211 7.85417 9.83133 7.49039 9.83133 7.04167V6.77485C10.2227 6.77101 10.6539 6.77083 11.1313 6.77083H14.2513C14.7288 6.77083 15.1599 6.77101 15.5513 6.77485ZM5.67518 11.1042C5.67149 11.5119 5.67133 11.9611 5.67133 12.4583V14.625C5.67133 16.18 5.67298 17.2645 5.77859 18.0829C5.8812 18.8778 6.06886 19.2987 6.3567 19.5986C6.64453 19.8984 7.04864 20.0939 7.81177 20.2008C8.59734 20.3108 9.63849 20.3125 11.1313 20.3125H15.2913C16.2777 20.3125 16.9653 20.3117 17.4984 20.2614C18.0209 20.2121 18.3178 20.1203 18.5413 19.986C18.8971 19.772 19.1924 19.4643 19.3978 19.0938C19.5269 18.8609 19.6149 18.5515 19.6623 18.0074C19.7106 17.4521 19.7113 16.7358 19.7113 15.7083V12.4583C19.7113 11.9611 19.7112 11.5119 19.7074 11.1042H5.67518Z' fill='var(--AccentColor)'/>
                </svg>
                <p>{selectValue.packDetails}</p>
                <svg xmlns='http://www.w3.org/2000/svg' width='0.875rem' height='0.5rem' viewBox='0 0 14 8' fill='none'>
                  <path d='M12.5 1L7 7L1.5 1' stroke='var(--AccentColor)' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              {dateDropDown.packDetails && (
                <DropDownComp
                  data={dropDownData}
                  setSelectedValue={setSelectedValue}
                  closeDropDown={() => setDropDown((prev) => ({ ...prev, packDetails: false}))}
                  handleSelectChange={handleSelectChange}
                  chartName='pack_details'
                />
              )}
            </div>
            <div className='chartArea'>
              {getBgvCountLoading ? (
                <MainLoader />
              ) : (
                <>
                  {bgvCountResp.length > 0 ? (
                    <BarChart marginValue={barMargin} data={bgvCountResp}/>
                  ) : (
                    <Empty sign='negative' size={6}/>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='verticalBarContainer'>
        <div className='heading'>
          <h1>Average Completion of Checks (in days)</h1>
        </div>
        <div className='chartArea'>
          {getCheckAverageDetailsLoading ? (
            <MainLoader />
          ) : (
            <>
              {apiCount.length > 0 ? (
                <VerticalBarChart marginValue={VerticalBarmargin} data={apiCount}/>
              ) : (
                <Empty sign='negative' size={8}/>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChartsComp;
